<template>
    <q-card class="producto-card-skeleton">
        <q-skeleton height="220px" />

        <q-card-section class="q-pa-md">
            <q-skeleton type="text" width="60%" class="q-mb-sm" />
            <q-skeleton type="text" width="85%" />
            <q-skeleton type="text" width="75%" class="q-mb-md" />

            <div class="row items-center justify-between q-mt-md">
                <q-skeleton type="text" width="40%" height="32px" />
                <q-skeleton type="circle" size="32px" />
            </div>
        </q-card-section>
    </q-card>
</template>

<style lang="scss" scoped>
.producto-card-skeleton {
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.08);
    height: 100%;
}
</style>
